import TableWithTitle from '@/components/TableWithTitle.vue';
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange } from "@/utils/transformers";
import { SELECTOR, PERIOD_FIELD, SEARCH_FUNNEL_OPPRTUNITIES_SEARCHES_FIELD, SEARCH_FUNNEL_PURCHASES_SHARE_FIELD, SEARCH_FUNNEL_TOP_PRODUCT_FIELD, SEARCH_FUNNEL_SHARE_OF_VOICE_FIELD, SEARCH_FUNNEL_BEST_POSITION_FIELD, SEARCH_FUNNEL_SOV_SPONSORED_FIELD, SEARCH_FUNNEL_NUMBER_OF_IMPRESSIONS_PER_SEARCH_FIELD, SEARCH_FUNNEL_CLICK_SHARE_FIELD, SEARCH_FUNNEL_ESTMATED_OPPORTUNITY_FIELD } from "@/utils/table_fields";
import AppIcon from '@/components/AppIcon.vue';
import { truncateString } from '@/utils';
import { mapState } from "vuex";
import { HugValue, DateValue, CurrencyValue, NumberValue, PercentageValue, OverlapBarValue, BoxedValue, BarWithValue, DotElement } from "@/components/tableElements";
import LiteTableMixin from '@/mixins/LiteTableMixin.vue';
import { DEFAULT_DATE_FORMATS, PERIOD_COLUMN_TITLES, SEARCH_FUNNEL_CTR_HEATMAP_COLORS, SEARCH_FUNNEL_CVR_HEATMAP_COLORS } from '@/utils/constants';
import FlexRow from '@/components/FlexRow.vue';
import moment from 'moment';
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import WrapTableWithShowMore from '@/components/WrapTableWithShowMore.vue';
import VariableStyledBar from '@/components/tableElements/VariableStyledBar.vue';
import LayerBars from "@/components/tableElements/LayerBars.vue";
import ImageElement from '@/components/tableElements/ImageElement.vue';
import { amz_sp_api_marketplace_ids_country_domains_flipped, country_code_amz_sp_api_marketplace_ids_flipped } from '@/utils/countries';
import WrapWithCopy from "@/components/WrapWithCopy.vue";
export default {
  name: "OpportunitiesPeriodTable",
  components: {
    HugValue,
    DateValue,
    CurrencyValue,
    NumberValue,
    PercentageValue,
    OverlapBarValue,
    FlexRow,
    SlotWithEvolutionValue,
    EvolutionValue,
    WrapTableWithShowMore,
    TableWithTitle,
    WrapWithPopover,
    AppIcon,
    BoxedValue,
    BarWithValue,
    DotElement,
    VariableStyledBar,
    LayerBars,
    ImageElement,
    WrapWithCopy
  },
  mixins: [LiteTableMixin],
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  emits: ["setDateRange", "refresh"],
  data() {
    return {
      country_code_amz_sp_api_marketplace_ids_flipped,
      amz_sp_api_marketplace_ids_country_domains_flipped,
      PERIOD_COLUMN_TITLES,
      SEARCH_FUNNEL_CTR_HEATMAP_COLORS,
      SEARCH_FUNNEL_CVR_HEATMAP_COLORS,
      evolCategory: {
        prev_period: "_vs_previous_period",
        same_period_ly: "_vs_previous_year"
      }
    };
  },
  computed: {
    ...mapState({
      periodTable: state => state.search_funnel.periodTable,
      tab: state => state.search_funnel.currentTabValue,
      period: state => state.search_funnel.period,
      currentPeriod: state => state.search_funnel.currentPeriod,
      periodCategory: state => state.search_funnel.periodCategory,
      products: state => state.search_funnel.products,
      targetings: state => state.search_funnel.targetings,
      targeting_types: state => state.search_funnel.targeting_types
    }),
    fields() {
      return [SELECTOR, {
        ...PERIOD_FIELD,
        class: 'right_shadow'
      }, SEARCH_FUNNEL_OPPRTUNITIES_SEARCHES_FIELD, SEARCH_FUNNEL_PURCHASES_SHARE_FIELD, SEARCH_FUNNEL_TOP_PRODUCT_FIELD, SEARCH_FUNNEL_SHARE_OF_VOICE_FIELD, SEARCH_FUNNEL_BEST_POSITION_FIELD, SEARCH_FUNNEL_SOV_SPONSORED_FIELD, SEARCH_FUNNEL_NUMBER_OF_IMPRESSIONS_PER_SEARCH_FIELD, SEARCH_FUNNEL_CLICK_SHARE_FIELD, SEARCH_FUNNEL_ESTMATED_OPPORTUNITY_FIELD];
    },
    items() {
      return this.periodTable[this.tab].items;
    },
    maxCharCount() {
      return this.periodTable[this.tab].maxCharCount;
    },
    minMax() {
      return this.periodTable[this.tab].minMax;
    },
    getDateValueFormat() {
      // Convert the current period to UPPER CASE
      const period = this.period.toUpperCase();
      return DEFAULT_DATE_FORMATS[period];
    },
    getPeriodColumnTitle() {
      return PERIOD_COLUMN_TITLES[this.period];
    },
    period_pager: {
      get() {
        return this.periodTable.period_page;
      },
      set(_) {
        this.$store.dispatch('searchFunnelIncrementPeriodPage');
        this.$emit('refresh');
      }
    },
    getThClass() {
      return field => {
        if (field && field.key === "no_impressions_per_search") {
          return [{
            ["not-allowed"]: this.products?.selectedValues?.length
          }];
        }
        return [];
      };
    },
    tableStyle() {
      return {
        '--table-length': this.items?.length || 0
      };
    }
  },
  methods: {
    truncateString,
    getDescriptionBasedOnKpiKey,
    getColorsBasedOnRange,
    handleDateClick(period) {
      period = moment(period);
      this.$emit("setDateRange", period);
    },
    handleDateReset() {
      this.$emit("setDateRange", null);
    },
    handleRowClick(item) {
      this.handleRowClicked(item, this.handleDateReset, this.handleDateClick, 'period_agg');
    },
    highlightBasedOnGranularity(item) {
      const granularityMap = {
        weekly: '2026-06-22',
        monthly: '2026-06-01',
        quarterly: '2026-04-01'
      };
      return item?.period_agg === granularityMap[this.period];
    }
  }
};